<template>
  <div id="delivered-tracking-point">
    <section v-if="this.getTrackingOverride()">
      <label for="tracking-point">How long ago was the delivered tracking point?</label>
      <select v-model="selected" name="lastTrackingUpdate" id="tracking-point">
        <option value="<5">Less than 5 days</option>
        <option value="5-30">5-30 days</option>
        <option value="30+">30 days +</option>
      </select>
    </section>
    <div v-if="(!this.getTrackingOverride() && this.getTrackingAge(5) === 'MEDIUM') || isDisplayBestEndeavours()">
      <p>As it has been over 5 days since the parcel was scanned as delivered, we will do our best to get as much information about this delivery to help resolve the enquiry.</p>
      <p>As couriers are delivering large amounts of parcels, their memory isn't as clear the longer time passes.</p>
    </div>
    <EscalateEnquiryForm v-if="(!this.getTrackingOverride() && (this.getTrackingAge(5) !== 'TOO_OLD')) || isEnquirable()"/>
    <div v-if="(!this.getTrackingOverride() && this.getTrackingAge(5) === 'TOO_OLD') || isTooOld()">
      <p>Due to the volume of parcels that are sent using the Evri network and the amount of parcels delivered, to enable a full fruitful investigation we do require all queries of this nature to be submitted within 30 days of sending the parcel. I am sorry to advise as this timeframe has now passed for this order, we would be unable to investigate this for you.</p>
      <p>We would ask that you now follow your standard claims procedure/agreement.</p>
    </div>
  </div>
</template>

<script>
import EscalateEnquiryForm from '../EscalateEnquiryForm'
import trackingJS from '../helpers/tracking.js';

export default {
  mixins: [trackingJS],
  data () {
    return {
      selected: false
    }
  },
  methods: {
    isEnquirable() {
      return this.selected === '<5' || this.selected === '5-30';
    },
    isDisplayBestEndeavours() {
      return this.selected === '5-30'
    },
    isTooOld() {
      return this.selected === '30+';
    }
  },
  components: {
    EscalateEnquiryForm
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sections/DeliveredTrackingPoint.vue